/**
 * Sprint 58 · F2 (cierre) — Catálogo oficial de salones (fuente ÚNICA).
 *
 * Los nueve salones oficiales seleccionables provienen EXCLUSIVAMENTE del
 * backend (`GET /api/plantillas/salones-catalogo`). El frontend NO mantiene
 * una lista oficial hardcodeada; este módulo sólo cachea la respuesta para
 * no re-consultar en cada montaje.
 */
import { useEffect, useState } from "react";
import { getCatalogoSalones } from "@/data/plantillasMesasStore";

let _cache = null; // string[] (nombres en el orden del backend)
let _promise = null;

/** Carga (o reutiliza) el catálogo oficial como array de nombres ordenados. */
export const cargarSalonesOficiales = async () => {
  if (_cache) return _cache;
  if (!_promise) {
    _promise = getCatalogoSalones()
      .then((arr) => {
        const nombres = (Array.isArray(arr) ? arr : [])
          .slice()
          .sort((a, b) => (a?.orden ?? 0) - (b?.orden ?? 0))
          .map((x) => x?.nombre)
          .filter((n) => typeof n === "string" && n);
        _cache = nombres;
        return nombres;
      })
      .catch((e) => {
        _promise = null; // permite reintento tras un fallo de red
        throw e;
      });
  }
  return _promise;
};

/** Hook: devuelve `{ salones, cargando }` con el catálogo oficial del backend. */
export const useSalonesOficiales = () => {
  const [salones, setSalones] = useState(_cache || []);
  const [cargando, setCargando] = useState(!_cache);
  useEffect(() => {
    let vivo = true;
    if (_cache) {
      setSalones(_cache);
      setCargando(false);
      return () => {};
    }
    setCargando(true);
    cargarSalonesOficiales()
      .then((n) => {
        if (vivo) {
          setSalones(n);
          setCargando(false);
        }
      })
      .catch(() => {
        if (vivo) setCargando(false);
      });
    return () => {
      vivo = false;
    };
  }, []);
  return { salones, cargando };
};
